import { ITaskSourceSystem } from '../models/task-models';
import TaskMapper from '../mappings/task-mapper';
import { Config, SourceSystem } from '../models/config-viewmodel';

class TaskService {
    private taskMapper = new TaskMapper();

    constructor() {}

    public getOpenTasks = (config: Config, HttpService: any) => {
        return this.getTasks(this.getOpenTasksQuery(config), HttpService, config);
    }

    private getTasks = (url: string, HttpService: any, config: Config): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: ITaskSourceSystem[]) => {
                resolve(result.map((taskSourceSystem: ITaskSourceSystem) => this.taskMapper.mapTaskSourceSystem(taskSourceSystem, config.language)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getOpenTasksQuery = (config: Config): string => {
        let query = '/api/employees/tasks';

        // TODO: remove when SAP is not used anymore
        if(config.sourceSystem as SourceSystem === SourceSystem.SAP) {
            query = `${config.apiBasePath}${query}/${config.userId}`;
        }

        return query;
    }
}

export default new TaskService();
